import { Component, EventEmitter, inject, input, Input, InputSignal, Output } from "@angular/core";

import { HelperTooltip } from "@bitwarden/web-vault/app/shared/utils/helper-tooltip";
import { DeviceDetectorService } from "ngx-device-detector";

@Component({
  selector: "modal-header",
  templateUrl: "./modal-header.component.html",
})
export class ModalHeaderComponent {
  @Input() title = "";
  @Input() subtitle = "";
  @Input() showBackButton = true;
  @Input() showCloseButton = true;
  @Input() isMatDialog = true;
  @Input() enableTooltip = false; // for ngIf of markup
  @Input() tooltipInfo = "";
  @Input() useLargeRoundedCorners = false;
  @Input() plainCloseButton = false;
  @Input() backButtonClass: string = "btn-icon";
  @Input() showEditButton = false;
  /** Opt-in override for the title span's font-size classes. Empty = default (tw-text-xl xs:tw-text-lg). */
  @Input() titleClass = "";
  @Input() forceMobileLayout = false;
  @Output() onBackClicked = new EventEmitter<void>();
  @Output() onCloseClicked = new EventEmitter<void>();
  @Output() onEditClicked = new EventEmitter<void>();
  customizedCloseIcon: InputSignal<string> = input("");
  protected deviceService = inject(DeviceDetectorService);
  protected get showMobileLayout(): boolean {
    return this.deviceService.isMobile() || this.forceMobileLayout;
  }
  tooltip: HelperTooltip;

  constructor() {
    this.tooltip = new HelperTooltip();
  }

  handleBackClick() {
    this.onBackClicked.emit();
  }

  handleClose() {
    this.onCloseClicked.emit();
  }
}
